document.addEventListener('DOMContentLoaded', () => {
  const heart = document.querySelector('.hero-heart');
  const leftPupil = document.querySelector('.left-pupil');
  const rightPupil = document.querySelector('.right-pupil');

  if (!heart || !leftPupil || !rightPupil) return;

  let currentX = 0;
  let currentY = 0;
  let targetX = 0;
  let targetY = 0;
  let lastMouseMove = Date.now();

  const hasMouse = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function animateEyes() {
    currentX += (targetX - currentX) * 0.12;
    currentY += (targetY - currentY) * 0.12;

    leftPupil.style.transform = `translate(${currentX}px, ${currentY}px)`;
    rightPupil.style.transform = `translate(${currentX}px, ${currentY}px)`;

    requestAnimationFrame(animateEyes);
  }

  if (hasMouse) {
    window.addEventListener('mousemove', (event) => {
      lastMouseMove = Date.now();

      const rect = heart.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width;
      const y = (event.clientY - rect.top) / rect.height;

      targetX = clamp((x - 0.5) * 70 - 55, -50, 10);
      targetY = clamp((y - 0.5) * 40, -20, 20);
    });

    window.addEventListener('mouseleave', () => {
      targetX = 0;
      targetY = 0;
    });

    setInterval(() => {
      const mouseIdle = Date.now() - lastMouseMove > 8000;

      if (mouseIdle) {
        targetX = Math.random() > 0.5 ? -35 : 8;
        targetY = Math.random() > 0.5 ? -8 : 6;

        setTimeout(() => {
          targetX = -18;
          targetY = 0;
        }, 700);
      }
    }, 10000);
  } else {
    setInterval(() => {
      targetX = Math.random() > 0.5 ? -35 : 8;
      targetY = Math.random() > 0.5 ? -8 : 6;

      setTimeout(() => {
        targetX = -18;
        targetY = 0;
      }, 1200);
    }, 3500);
  }

  function blink() {
    heart.classList.add('blink');

    setTimeout(() => {
      heart.classList.remove('blink');

      if (Math.random() < 0.3) {
        setTimeout(() => {
          heart.classList.add('blink');

          setTimeout(() => {
            heart.classList.remove('blink');
          }, 100);
        }, 130);
      }
    }, 110);

    const nextBlink = 3000 + Math.random() * 5000;
    setTimeout(blink, nextBlink);
  }

  animateEyes();
  setTimeout(blink, 2000);
});